import { render } from "./ratingSlide.vue?vue&type=template&id=44a37b21&scoped=true"
import script from "./ratingSlide.vue?vue&type=script&lang=js"
export * from "./ratingSlide.vue?vue&type=script&lang=js"

import "./ratingSlide.vue?vue&type=style&index=0&id=44a37b21&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a37b21"]])

export default __exports__